import { all, fork } from 'redux-saga/effects';

import userSaga from './user/sagas';
import regionSaga from './region/sagas';
import siteSaga from './site/sagas';
import userRolesSaga from './userRoles/sagas';
import reportSaga from './report/sagas';
import districtSaga from './district/sagas';
import chiefdomSaga from './chiefdom/sagas';
import divisionSaga from './division/sagas';
import branchSaga from './branch/sagas';

export function* rootSaga() {
  yield all([fork(userSaga)]);
  yield all([fork(regionSaga)]);
  yield all([fork(siteSaga)]);
  yield all([fork(userRolesSaga)]);
  yield all([fork(reportSaga)]);
  yield all([fork(districtSaga)]);
  yield all([fork(chiefdomSaga)]);
  yield all([fork(divisionSaga)]);
  yield all([fork(branchSaga)]);
}
